import { ImageSize, ProfileAvatar } from '@pbk-web/ui';
import { DateUtils } from '@pbk-web/utils';
import { type FC, useMemo } from 'react';

import { useFormAction } from '../../../contexts/FormActionContext';
import { useFormRendererInfo } from '../../../contexts/FormRendererContext';
import useFetchClientUsers from '../../../hooks/useFetchClientUsers';

const InlineAnswerHistory: FC = () => {
  const { currentAction } = useFormAction();
  const { config } = useFormRendererInfo();
  const { data: clientUsers } = useFetchClientUsers();

  const history = useMemo(() => {
    return config.answerMetaData?.[currentAction.fieldId || currentAction.id];
  }, [config.answerMetaData, currentAction.fieldId, currentAction.id]);

  const userId = useMemo(() => history?.createdById, [history?.createdById]);
  const createdUtc = useMemo(() => DateUtils.formatDateTime(new Date(history?.createdUtc ?? 0)), [history?.createdUtc]);

  const user = useMemo(() => clientUsers?.find((u) => u.id === userId), [clientUsers, userId]);

  if (!history || currentAction.noninteractive) {
    return null;
  }

  return (
    <div className="mt-2 flex items-center gap-2">
      <ProfileAvatar size={ImageSize.XS} user={user} /> {createdUtc}
    </div>
  );
};

export default InlineAnswerHistory;
